<template>
  <div class="helpPerformanceBox">
    <div class="helpcloginCon">
       <div class="bigTitle" @click="backFn('showa')"><span ></span>创建履约</div>
      <div class="smallTile" v-for="(item,index) in flowList" v-if="showa">
        <p>{{item.con}} </p>
        <img :src="item.img" v-if="item.img!=''">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      showa:true,
      flowList:[
        {
          con:'1.履约管理-创建履约任务',
          img:require('../../../assets/images/helpCenter/cjly.png')
        },
        {
          con:'2.选择签署完成的合同名称',
          img:''
        },
        {
          con:'3.填写履约任务名称',
          img:''
        },
        {
          con:'4.选择周期',
          img:''
        },
        {
          con:'5.选择任务执行方',
          img:''
        },
        {
          con:'6.选择最晚执行时间',
          img:''
        },
        {
          con:'7.选择任务确认方',
          img:''
        },
        {
          con:'8.选择最晚确认时间 注：时间不能早于最晚执行时间',
          img:''
        },
        {
          con:'9.选择前置履约任务（此合同之前创建过履约任务）',
          img:''
        },
        {
          con:'10.填写任务说明',
          img:''
        },
        {
          con:'11.点击提交',
          img:''
        },
        {
          con:'12.履约任务创建成功',
          img:''
        },

      ]
    }
  },
  methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
  
}
</script>